import { Modal } from '@mui/material'
import React from 'react'
import Mapa from 'Components/Map'

export const EditAddressModal = ({
  addressDetails,
  onClose,
  onSave,
  setIsErrorAddressModal,
  setMessageAddressModal,
}) => {
  return (
    <Modal
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: window.innerWidth - 491,
        alignItems: 'center',
        zIndex: 99999,
      }}
      onClose={onClose}
      open={true}
      data-testid="modal-edit-address">
      <>
        <Mapa
          setSelectedAddress={() => {}}
          setDireccion={() => {}}
          handleMetodoEntrega={onSave}
          isModalScreen={true}
          defaultValues={addressDetails}
          onClose={onClose}
          setIsErrorAddressModal={setIsErrorAddressModal}
          setMessageAddressModal={setMessageAddressModal}
        />
      </>
    </Modal>
  )
}
